exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-question-component .v-radio>.v-label{margin-left:3px;margin-top:4px}.module-question-component .question-content img{width:100%;max-width:100%}.choice-content-container p{margin:0}.popup-modal{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000;width:80%;max-width:500px}", ""]);

// exports
